module.exports = __webpack_public_path__ + "img/baseline-keyboard_arrow_right-24px.f9ea43e5.svg";